import type { StatusText } from './types.js';

export const statusTexts: StatusText = {
  Undefined: { full: '-', short: '-' },
  NotStarted: { full: '-', short: '-' },
  AboutToStart: { full: '-', short: '-' },
  Live: { full: 'Live', short: 'LIVE' },
  FirstPeriod: { full: 'Första perioden', short: '1:A' },
  SecondPeriod: { full: 'Andra perioden', short: '2:A' },
  ThirdPeriod: { full: 'Tredje perioden', short: '3:E' },
  FirstHalf: { full: 'Första halvlek', short: '1:A' },
  SecondHalf: { full: 'Andra halvlek', short: '2:A' },
  FirstQuarter: { full: '1:A quarter', short: 'Q1' },
  SecondQuarter: { full: '2:A quarter', short: 'Q2' },
  ThirdQuarter: { full: '3:E quarter', short: 'Q3' },
  FourthQuarter: { full: '4:E quarter', short: 'Q4' },
  FirstInning: { full: 'Första omgången', short: '1:A' },
  SecondInning: { full: 'Andra omgången', short: '2:A' },
  ThirdInning: { full: 'Tredje omgången', short: '3:E' },
  FourthInning: { full: 'Fjärde omgången', short: '4:E' },
  FifthInning: { full: 'Femte omgången', short: '5:E' },
  SixthInning: { full: 'Sjätte omgången', short: '6:E' },
  SeventhInning: { full: 'Sjunde omgången', short: '7:E' },
  EighthInning: { full: 'Åttånde omgången', short: '8:E' },
  NinthInning: { full: 'Nionde omgången', short: '9:E' },
  Overtime: { full: 'Övertid (ÖT)', short: 'ÖT' },
  FirstExtraPeriod: { full: 'Första extraperioden', short: '1:A ET' },
  SecondExtraPeriod: { full: 'Andra extraperioden', short: '2:A ET' },
  ThirdExtraPeriod: { full: 'Tredje extraperioden', short: '3:E ET' },
  AwaitingPenalties: { full: 'Inväntar straffar', short: 'PAUS' },
  AwaitingExtratime: { full: 'Inväntar extratid', short: 'PAUS' },
  Penalties: { full: 'Straffar (STR)', short: 'STR' },
  Pause: { full: 'Paus', short: 'PAUS' },
  Interrupted: { full: 'Avbruten', short: 'AVBR' },
  Abandoned: { full: 'Avbruten', short: 'AVBR' },
  Postponed: { full: 'Uppskjuten', short: 'UPPS' },
  Delayed: { full: 'Försenad', short: 'FÖRS' },
  Cancelled: { full: 'Inställd', short: 'INST' },
  Ended: { full: 'Fulltid (FT)', short: 'FT' },
  Closed: { full: 'Stängd', short: 'STÄNGD' },
  Halftime: { full: 'Halvtid (HT)', short: 'HT' },
  Fulltime: { full: 'Fulltid (FT)', short: 'FT' },
  Extratime: { full: 'Extratid (ET)', short: 'ET' },
  EndedAfterExtratime: { full: 'Slut efter extratid (ET)', short: 'ET' },
  EndedAfterPenalties: { full: 'Slut efter straffar (STR)', short: 'STR' },
  FallbackFourthPeriod: { full: 'Fjärde perioden', short: '4:E' },
  FallbackFifthPeriod: { full: 'Femte perioden', short: '5:E' },
  FallbackFirstSet: { full: 'Första set', short: '1:A' },
  FallbackSecondSet: { full: 'Andra set', short: '2:A' },
  FallbackThirdSet: { full: 'Tredje set', short: '3:E' },
  FallbackFourthSet: { full: 'Fjärde set', short: '4:e' },
  FallbackFifthSet: { full: 'Femte set', short: '5:E' },
  FallbackExtraTimeHalftime: { full: 'Halvtid Extratid', short: 'HT/ET' },
  FallbackSuspended: { full: 'Speluppehåll', short: 'UPPH' },
  FallbackWalkover: { full: 'Walkover', short: 'WO' },
  FallbackParticipantRetired: { full: 'Deltagare pensionerad', short: 'AVBR' },
  FallbackInFirstBreak: { full: 'Första paus', short: 'PAUS' },
  FallbackInSecondBreak: { full: 'Andra paus', short: 'PAUS' },
  FallbackInThirdBreak: { full: 'Tredje paus', short: 'PAUS' },
  FallbackGoldenSet: { full: 'Golden set', short: 'GOLD' },
  FallbackSixthSet: { full: 'Sjätte set', short: '6:E' },
  FallbackSeventhSet: { full: 'Sjunde set', short: '7:E' },
  FallbackFrame1: { full: 'Frame 1', short: '1:A' },
  FallbackFrame2: { full: 'Frame 2', short: '2:A' },
  FallbackFrame3: { full: 'Frame 3', short: '3:E' },
  FallbackFrame4: { full: 'Frame 4', short: '4:E' },
  FallbackFrame5: { full: 'Frame 5', short: '5:E' },
  FallbackFrame6: { full: 'Frame 6', short: '6:E' },
  FallbackFrame7: { full: 'Frame 7', short: '7:E' },
  FallbackFrame8: { full: 'Frame 8', short: '8:E' },
  FallbackFrame9: { full: 'Frame 9', short: '9:E' },
  FallbackFrame10: { full: 'Frame 10', short: '10:E' },
  FallbackFrame11: { full: 'Frame 11', short: '11:E' },
  FallbackFrame12: { full: 'Frame 12', short: '12:E' },
  FallbackFrame13: { full: 'Frame 13', short: '13:E' },
  FallbackFrame14: { full: 'Frame 14', short: '14:E' },
  FallbackFrame15: { full: 'Frame 15', short: '15:E' },
  FallbackFrame16: { full: 'Frame 16', short: '16:E' },
  FallbackFrame17: { full: 'Frame 17', short: '17:E' },
  FallbackFrame18: { full: 'Frame 18', short: '18:E' },
  FallbackFrame19: { full: 'Frame 19', short: '19:E' },
  FallbackFrame20: { full: 'Frame 20', short: '20:E' },
  FallbackFrame21: { full: 'Frame 21', short: '21:A' },
  FallbackFrame22: { full: 'Frame 22', short: '22:A' },
  FallbackFrame23: { full: 'Frame 23', short: '23:E' },
  FallbackFrame24: { full: 'Frame 24', short: '24:E' },
  FallbackFrame25: { full: 'Frame 25', short: '25:E' },
  FallbackFrame26: { full: 'Frame 26', short: '26:E' },
  FallbackFrame27: { full: 'Frame 27', short: '27:E' },
  FallbackFrame28: { full: 'Frame 28', short: '28:E' },
  FallbackFrame29: { full: 'Frame 29', short: '29:E' },
  FallbackFrame30: { full: 'Frame 30', short: '30:E' },
  FallbackFrame31: { full: 'Frame 31', short: '31:A' },
  FallbackFrame32: { full: 'Frame 32', short: '32:A' },
  FallbackFrame33: { full: 'Frame 33', short: '33:E' },
  FallbackFrame34: { full: 'Frame 34', short: '34:E' },
  FallbackFrame35: { full: 'Frame 35', short: '35:E' },
  FallbackFrame36: { full: 'Frame 36', short: '36:E' },
  FallbackFrame37: { full: 'Frame 37', short: '37:E' },
  FallbackAwaitingSuddenDeath: { full: 'Inväntar Sudden Death', short: 'PAUS' },
  FallbackInSuddenDeath: { full: 'Sudden Death', short: 'ÖT' },
  FallbackEndedAfterSuddenDeath: { full: 'Slut efter övertid (ÖT)', short: 'ÖT' },
  FallbackFirstInningsHomeTeam: { full: 'Första omgången', short: '1:A' },
  FallbackFirstInningsAwayTeam: { full: 'Första omgången', short: '1:A' },
  FallbackSecondInningsHomeTeam: { full: 'Andra omgången', short: '2:A' },
  FallbackSecondInningsAwayTeam: { full: 'Andra omgången', short: '2:A' },
  FallbackAwaitingSuperOver: { full: 'Inväntar övertid (ÖT)', short: 'ÖT' },
  FallbackInSuperOverHomeTeam: { full: 'Övertid (ÖT)', short: 'ÖT' },
  FallbackInSuperOverAwayTeam: { full: 'Övertid (ÖT)', short: 'ÖT' },
  FallbackEndedAfterSuperOver: { full: 'Slut efter övertid (ÖT)', short: 'ÖT' },
  FallbackStumps: { full: 'Fulltid', short: 'FT' },
  FallbackDefaulted: { full: 'Avbruten', short: 'AVBR' },
  FallbackWalkoverHomeTeamWon: { full: 'Walkover hemmavinst', short: 'WO' },
  FallbackWalkoverAwayTeamWon: { full: 'Walkover bortavinst', short: 'WO' },
  FallbackParticipantRetiredHomeTeamWon: { full: 'Deltagare pensionerad', short: 'AVBR' },
  FallbackParticipantRetiredAwayTeamWon: { full: 'Deltagare pensionerad', short: 'AVBR' },
  FallbackDefaultedHomeTeamWon: { full: 'Avbruten', short: 'AVBR' },
  FallbackDefaultedAwayTeamWon: { full: 'Avbruten', short: 'AVBR' },
  FallbackLunchBreak: { full: 'Lunchpaus', short: 'PAUS' },
  FallbackTeaBreak: { full: 'Tepaus', short: 'PAUS' },
};

export const config = {
  statusTexts,
};
